import styled from '@emotion/styled';

export const AppWrapper = styled.div<{ primaryColour: string }>`
  min-height: 650px;
  --lp-colors-primary: ${(props) => props.primaryColour || '0,22,209'};
`;
